'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NOT_DELETED = exports.NOT_DELETED = 'NOT_DELETED';
var SOFT_DELETED = exports.SOFT_DELETED = 'SOFT_DELETED';
var HARD_DELETED = exports.HARD_DELETED = 'HARD_DELETED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/messageDeleteStatus.js
// module id = 747
// module chunks = 2 3